const EventEmitter = {
  events: {
    /**
     * Events for Tesseract
     */
    SEND_SNACK_MESSAGE: "SEND_SNACK_MESSAGE",
    SEND_LOGIN_REQUEST: "SEND_LOGIN_REQUEST",
    START_LOADING_REQUEST: "START_LOADING_REQUEST",
    STOP_LOADING_REQUEST: "STOP_LOADING_REQUEST",
  },

  subscribedEvents: {},

  dispatch: function (event, data) {
    if (!this.subscribedEvents[event]) return;
    this.subscribedEvents[event].forEach((callback) => callback(data));
  },

  subscribe: function (event, callback) {
    if (!this.subscribedEvents[event]) this.subscribedEvents[event] = [];
    this.subscribedEvents[event].push(callback);
  },
};
module.exports = { EventEmitter };
